import { usePage } from '@inertiajs/vue3'
import moment from 'moment';
import "moment/dist/locale/nl"

export function formatDateTime(date) {

    var formattedDate = moment(String(date)).locale('nl').format('H:mm DD-MM-YYYY')


    return formattedDate;
}

export function formatDate(date) {
    return moment(String(date)).locale('nl').format('DD-MM-YYYY');
}

export function formatTime(date) {

    return moment(String(date)).locale('nl').format('H:mm');
}

export function formatMonth(date) {

    return moment().month(date).locale('nl').format('MMMM');
}